import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { getStudentById, updateStudent } from "../api/studentsService";

const UpdateStudentComponent = (props) => {
    const closeRef = useRef();

    const [name, setName] = useState("");
    const [family, setFamily] = useState("");
    const [parentMobile, setParentMobile] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        getStudentByIdHandler();
    }, [props.student]);

    const updateStudentHandler = async () => {
        if (!props.student || isSaving) return;

        setIsSaving(true);
        try {
            await updateStudent(props.student.id, name, family, parentMobile);
            props.afterUpdateStudent({
                ...props.student,
                name,
                family,
                parentMobile
            });
            closeRef.current.click();
            toast.success("اطلاعات دانش‌آموز با موفقیت ویرایش شد.");
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "ویرایش اطلاعات دانش‌آموز انجام نشد."
            );
        } finally {
            setIsSaving(false);
        }
    };

    const getStudentByIdHandler = async () => {
        if (!props.student) return;

        try {
            const studentData = await getStudentById(props.student.id);
            setName(studentData.student.name || "");
            setFamily(studentData.student.family || "");
            setParentMobile(studentData.student.parentMobile || "");
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "دریافت اطلاعات دانش‌آموز انجام نشد."
            );
        }
    };

    return (
        <div className="card-body p-0">
            <div className="modal fade" id="updateStudentModal" tabIndex="-1" aria-labelledby="updateStudentModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="updateStudentModalLabel">ویرایش دانش‌آموز</h1>
                        </div>
                        <div className="modal-body">
                            <input value={name} className="form-control" type="text" placeholder="نام دانش‌آموز" onChange={(e) => setName(e.target.value)} />
                            <input value={family} className="form-control mt-3" type="text" placeholder="فامیل دانش‌آموز" onChange={(e) => setFamily(e.target.value)} />
                            <input value={parentMobile} className="form-control mt-3" type="number" placeholder="موبایل ولی دانش‌آموز" onChange={(e) => setParentMobile(e.target.value)} />
                        </div>
                        <div className="modal-footer">
                            <button ref={closeRef} type="button" className="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                            <button type="button" className="btn btn-primary" disabled={isSaving} onClick={updateStudentHandler}>
                                {isSaving ? "در حال ذخیره..." : "ذخیره"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateStudentComponent;
